import PlayerService from "@/common/player.service";

const state = {
  visible: false,
  playing: false,
  playingInfo: {
    title: "",
    subtitle: "",
  },
  titleVisible: false,
  noMoreItemsDialogVisible: false,
  signupToKeepProgressVisible: false,
};

const getters = {
  playerVisible: (state) => state.visible,
  playing: (state) => state.playing,
  playingInfo: (state) => state.playingInfo,
  titleVisible: (state) => state.titleVisible,
  noMoreItemsDialogVisible: (state) => state.noMoreItemsDialogVisible,
  signupToKeepProgressVisible: (state) => state.signupToKeepProgressVisible,
};

const actions = {
  togglePlay({ commit, rootGetters }) {
    if (PlayerService.isPlaying()) {
      PlayerService.stop();
      commit("setPlaying", false);
      // only if it's not logged in
      // if (rootState.auth.loggedIn )
      if (!rootGetters.loggedIn) {
        commit("displaySignupToKeepProgressDialog", true);
      }
    } else {
      PlayerService.play();
      commit("setPlaying", true);
    }
  },
  hidePlayer({ commit }) {
    commit("displayPlayer", false);
  },
  stop({ commit }) {
    PlayerService.stop();
    commit("setPlaying", false);
  },
  play({ commit }) {
    PlayerService.play();
    commit("setPlaying", true);
    commit("displayPlayer", true);
  },
  updatePlayingInfo({ commit }, payload) {
    commit("setPlayingInfo", payload);
  },
  toggleTitle({ commit }) {
    commit("toggleTitle");
  },
  showNoMoreItemsDialog({ commit }) {
    commit("displayNoMoreItemsDialog", true);
  },
  hideNoMoreItemsDialog({ commit }) {
    commit("displayNoMoreItemsDialog", false);
  },
  displaySignupToKeepProgress({ commit }, value) {
    commit("displaySignupToKeepProgressDialog", value);
  },
};

const mutations = {
  displayPlayer: (state, visible) => (state.visible = visible),
  setPlaying: (state, playing) => (state.playing = playing),
  setPlayingInfo: (state, payload) => Object.assign(state.playingInfo, payload),
  toggleTitle: (state) => (state.titleVisible = !state.titleVisible),
  displayNoMoreItemsDialog: (state, visible) =>
    (state.noMoreItemsDialogVisible = visible),
  displaySignupToKeepProgressDialog: (state, visible) =>
    (state.signupToKeepProgressVisible = visible),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
